// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ContentFormController from "./content_form_controller"
application.register("content-form", ContentFormController)

import CropperController from "./cropper_controller"
application.register("cropper", CropperController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HugerteController from "./hugerte_controller"
application.register("hugerte", HugerteController)

import MediaActionsController from "./media_actions_controller"
application.register("media-actions", MediaActionsController)

import MediaEditController from "./media_edit_controller"
application.register("media-edit", MediaEditController)

import MediaFiltersController from "./media_filters_controller"
application.register("media-filters", MediaFiltersController)

import MediaLibraryController from "./media_library_controller"
application.register("media-library", MediaLibraryController)

import MediaLibraryModalController from "./media_library_modal_controller"
application.register("media-library-modal", MediaLibraryModalController)

import MediaUploadController from "./media_upload_controller"
application.register("media-upload", MediaUploadController)

import MultipleAssetsController from "./multiple_assets_controller"
application.register("multiple-assets", MultipleAssetsController)

import ReportTypeController from "./report_type_controller"
application.register("report-type", ReportTypeController)

import SectionGroupController from "./section_group_controller"
application.register("section-group", SectionGroupController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import VersionPreviewController from "./version_preview_controller"
application.register("version-preview", VersionPreviewController)
